module.exports = __webpack_public_path__ + "img/IMDB_logo.27642d25.png";